import React from 'react';
import PropTypes from 'prop-types';

import Picture from '../../Util/Picture/Picture';
import Slider from '../../Util/Slider/SliderView';

// import assets
import './compareImagesModule.scss';


class CompareImagesModuleView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      desc: props.images[0].desc,
    };

    this.changeImageDesc = this.changeImageDesc.bind(this);
  }

  changeImageDesc(newIndex) {
    this.setState({
      desc: this.props.images[newIndex].desc,
    });
  }

  render() {
    const sliderSettings = {
      responsive: [
        {
          breakpoint: 767,
          settings: {
            accessibility: true,
            variableWidth: true,
            centerMode: false,
            infinite: false,
            vertical: false,
            initialSlide: 0,
            centerPadding: '0px',
            arrows: true,
            adaptiveHeight: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            afterChange: this.changeImageDesc,
          },
        },
        {
          breakpoint: 9999999,
          settings: 'unslick',
        },
      ],
    };
    const length = this.props.images.length;
    let lengthClass = '';
    switch (length) {
      case 2:
        lengthClass = 'm-comp-images-module__image--two';
        break;
      case 3:
        lengthClass = 'm-comp-images-module__image--three';
        break;
      default:
        lengthClass = '';
    }
    return (
      <div className="m-article-module">
        <div className={'m-comp-images-module'}>
          <Slider sliderSettings={sliderSettings}>
            {this.props.images.map((image, index) => {
              const imageIndex = `image-${index}`;
              return (
                <div key={imageIndex} className={`m-comp-images-module__image ${lengthClass}`}>
                  <Picture
                    class={'m-comp-images-module__pic'}
                    src={{
                      sm: image.src['750'],
                      md: image.src['1020'],
                      lg: image.src['1600'],
                      xl: image.src['1900'],
                      xxl: image.src['2560'],
                      xxxl: image.src['2560'],
                      default: image.src.default,
                    }}
                    alt={image.alt}
                    imageCollection={this.props.images}
                    collectionIndex={index}
                  />
                  <div className={'m-comp-images-module__img-desc m-comp-images-module__img-desc--desktop'} dangerouslySetInnerHTML={{ __html: image.desc }} />
                </div>
              );
            })}
          </Slider>
          <div className={'m-comp-images-module__img-desc m-comp-images-module__img-desc--mobile'} dangerouslySetInnerHTML={{ __html: this.state.desc }} />
        </div>
      </div>
    );
  }
}

CompareImagesModuleView.propTypes = {
  images: PropTypes.arrayOf(PropTypes.shape({
    src: PropTypes.shape({
      sm: PropTypes.string,
      md: PropTypes.string,
      lg: PropTypes.string,
      xl: PropTypes.string,
      xxl: PropTypes.string,
      default: PropTypes.string,
    }),
    alt: PropTypes.string,
    desc: PropTypes.string,
  })),
};

CompareImagesModuleView.defaultProps = {
  images: [
    {
      sm: '',
      md: '',
      lg: '',
      xl: '',
      xxl: '',
      default: '',
    },
  ],
};

export default CompareImagesModuleView;



// WEBPACK FOOTER //
// ./frontend/js/Components/Modules/CompareImagesModule/CompareImagesModuleView.jsx